import $ from 'jquery';
import mapboxgl from '!mapbox-gl';

import { changeExaggeration, clearMarkers, flyTo, getPageData, initLightboxes, map, mapInitialized, mapMarkers } from './main';
import { $Elements, Classes } from '../global/constants';

export function homeEnter() {

	if(map) {

		if(mapInitialized) {
			initMarkers();
			$('#welcome').remove();
		}
		else {
			$Elements.document.on('map.initialized', initMarkers);
			$('#welcome').addClass('show');
		}
	}
}

export function homeLeave() {
	clearMarkers();
}

async function initMarkers() {

	const data = getPageData();

	if(data && data.markers) {

		for(const marker of data.markers) {

			const markerElement = $(marker.marker);

			mapMarkers.push(new mapboxgl.Marker({
				element: markerElement[0],
				anchor: marker.position,
			}).setLngLat(marker.coordinates).addTo(map));

			map.on('moveend', () => markerElement.addClass(Classes.active));
		}
	}

	initLightboxes();

	await flyTo({
		center: [-45, 45],
		zoom: 2.5,
		pitch: 0,
		bearing: 0,
	});

	changeExaggeration(1);

}
